/** 识别文案中的邮箱地址（用于条款、FAQ 等 i18n 静态文案） */
export const EMAIL_RE = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g

/** 扁平 List 项标题如 "2.1 Account Information" */
export function isLegalSubSectionTitle(title) {
  return /^\d+\.\d+/.test(String(title ?? '').trim())
}

/**
 * subList 项标题与正文（优先 `title`；否则从 desc 首行解析 "9.1 …"）
 * @returns {{ title: string, body: string }}
 */
export function parseLegalSubListItem(sub) {
  const explicit = String(sub?.title ?? '').trim()
  if (explicit) {
    return { title: explicit, body: String(sub?.desc ?? '') }
  }

  const desc = String(sub?.desc ?? '')
  const [firstLine = '', ...rest] = desc.split('\n')
  const heading = firstLine.trim()
  if (
    /^\d+\.\d+\s/.test(heading)
    && heading.length <= 120
    && !heading.includes('●')
  ) {
    return {
      title: heading,
      body: rest.join('\n').replace(/^\n+/, ''),
    }
  }

  return { title: '', body: desc }
}

/** 按 \\n 拆行，保留空行以形成段落间距 */
export function splitTextLines(text) {
  return String(text ?? '').split('\n')
}

/** 将单行拆为纯文本与邮箱片段，供模板渲染 mailto 链接 */
export function linkifyLine(line) {
  const parts = []
  let lastIndex = 0
  const re = new RegExp(EMAIL_RE.source, 'g')
  let match = re.exec(line)
  while (match) {
    if (match.index > lastIndex) {
      parts.push({ type: 'text', value: line.slice(lastIndex, match.index) })
    }
    parts.push({ type: 'email', value: match[1] })
    lastIndex = match.index + match[0].length
    match = re.exec(line)
  }
  if (lastIndex < line.length) {
    parts.push({ type: 'text', value: line.slice(lastIndex) })
  }
  if (!parts.length) {
    parts.push({ type: 'text', value: line })
  }
  return parts
}
